<div class="col-md-12">
    <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>

    <div *ngIf="!loading && subscription">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h3>Subscription Details</h3>
            <button class="btn btn-outline-secondary" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back to List
            </button>
        </div>

        <div class="card mb-4">
            <div class="card-header">
                <h5 class="mb-0">Subscription Info</h5>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <p><strong>Package:</strong> {{ subscription.packageTitle }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Amount:</strong> {{ subscription.amount | number:'1.0-0' }} XAF</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Period:</strong> {{ subscription.period || 'N/A' }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Status:</strong>
                            <span class="badge" [ngClass]="{
                                'bg-success': subscription.status === 'ACTIVE',
                                'bg-warning': subscription.status === 'INACTIVE',
                                'bg-danger': subscription.status === 'EXPIRED'
                            }">{{ subscription.status }}</span>
                        </p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Start Date:</strong> {{ subscription.startDate | date:'medium' }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>End Date:</strong> {{ subscription.endDate | date:'medium' }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header">
                <h5 class="mb-0">Seller Information</h5>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <p><strong>Name:</strong> {{ subscription.seller?.companyName || (subscription.seller?.firstName + ' ' + subscription.seller?.lastName) }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Type:</strong> {{ subscription.seller?.sellerType }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Status:</strong> {{ subscription.seller?.status }}</p>
                    </div>
                    <div class="col-md-6" *ngIf="subscription.seller?.operationalInfo">
                        <p><strong>Email:</strong> {{ subscription.seller?.operationalInfo?.companyEmail }}</p>
                    </div>
                    <div class="col-md-6" *ngIf="subscription.seller?.operationalInfo">
                        <p><strong>Phone:</strong> {{ subscription.seller?.operationalInfo?.companyPhoneNumber }}</p>
                    </div>
                    <div class="col-md-6" *ngIf="subscription.seller?.operationalInfo">
                        <p><strong>Location:</strong> {{ subscription.seller?.operationalInfo?.city }}, {{ subscription.seller?.operationalInfo?.country }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header">
                <h5 class="mb-0">Payment Information</h5>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <p><strong>Amount Paid:</strong> {{ subscription.payment?.amount | number:'1.0-0' }} {{ subscription.payment?.currency }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Payment Method:</strong> {{ subscription.payment?.paymentMethod }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Transaction Ref:</strong> {{ subscription.payment?.transactionRef }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Payment Date:</strong> {{ subscription.payment?.paymentDate ? (subscription.payment?.paymentDate | date:'medium') : 'N/A' }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Payment Status:</strong>
                            <span class="badge" [ngClass]="{
                                'bg-success': subscription.payment?.status === 'SUCCESS',
                                'bg-warning': subscription.payment?.status === 'PENDING',
                                'bg-danger': subscription.payment?.status === 'FAILED'
                            }">{{ subscription.payment?.status }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-4">
            <div class="card-header">
                <h5 class="mb-0">Buyer Information</h5>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <p><strong>Name:</strong> {{ subscription.payment?.user?.firstName }} {{ subscription.payment?.user?.lastName }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Email:</strong> {{ subscription.payment?.user?.email }}</p>
                    </div>
                    <div class="col-md-6">
                        <p><strong>Phone:</strong> {{ subscription.payment?.user?.phone }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
